import settings from 'services/app-settings';

export const NOTIFICATIONS_REST_API_BASE_PATH = `${settings.api.dashboardGatewayBasePath}/notifications`;
